import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import AccordionFromUiReact from '@ertelecom/ui-react/components/accordion';

export const Container = styled.div`
    display: block;
    max-width: calc(100% - 20px);
    width: 1360px;
    margin: 0 auto;
    @media(max-width: 1550px) {
        width: 1032px;
    }
    @media(max-width: 1240px) {
        width: 803px;
    }
    @media(max-width: 985px) {
        width: 700px;
    }
    @media(max-width: 720px) {
        width: calc(100% - 30px);
    }
`;

export const Wrapper = styled.div`
    display: block;
    width: 100%;
    background-color: ${ props => props.bgColor ? props.bgColor : '#333333'};
    padding: 120px 0;
`;

export const Title = styled.h2`
    display: block;
    font-family: ${FONTS.regular}, Arial, Helvetica, sans-serif;
    font-size: 32px;
    color: ${COLORS.white};
    margin-bottom: 50px;
    @media(max-width: 1550px) {
        font-size: 24px;
        margin-bottom: 40px;
    }
    @media(max-width: 985px) {
        margin-bottom: 30px;
    }
`;

export const Accordion = styled(AccordionFromUiReact)`
    margin-bottom: 10px;
`;

export const AnswerTitle = styled.div`
    display: block;
    font-family: ${FONTS.regular}, Arial, Helvetica, sans-serif;
    font-size: 16px;
    color: ${COLORS.white};
    margin-bottom: 10px;
    line-height: 1.33;
`;

export const Answers = styled.div`
    display: block;
`;

export const AnswerText = styled.div`
    display: block;
    font-family: ${FONTS.light}, Arial, Helvetica, sans-serif;
    font-size: 16px;
    color: ${COLORS.white};
    margin-bottom: 20px;
    line-height: 1.33;
    a {
        color: ${COLORS.white};
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const AnswerList = styled.div`
    display: block;
    font-family: ${FONTS.light}, Arial, Helvetica, sans-serif;
    font-size: 16px;
    color: ${COLORS.white};
    margin-bottom: 20px;
    line-height: 1.33;
`;

export const AnswerItem = styled.div`
    padding-left: 19px;
    position: relative;
    margin-bottom: 15px;
    &:before {
        display: block;
        content: '';
        position: absolute;
        top: 5px;
        left: 0;
        width: 9px;
        height: 9px;
        background-color: ${COLORS.darkGrey};
        border-radius: 50%;
    }
`;
